<script>
import { mapActions } from 'vuex';
import i18n from "@/plugins/i18n";
import axios from 'axios';
import Subscription from "./subscription.vue";
import StarterComplete from "./registerCompleteStarter.vue";

export default {
    components: {
        Subscription,
        StarterComplete
    },
    data(){
        return {
            registeredAsStarter: false,
            activeStep: 0,
            passwordInput: "password",

            // initial values //
            employeeCount: [
                {
                    text: "1-25",
                    value: new Array(2) // first index is the ID, second index is the max value
                },
                {
                    text: "26-50",
                    value: new Array(2)
                },
                {
                    text: "51-100",
                    value: new Array(2)
                },
                {
                    text: "101-250",
                    value: new Array(2)
                },
                {
                    text: "250-500",
                    value: new Array(2)
                },
                {
                    text: "500+",
                    value: new Array(2)
                }
            ],
            facilityNumber: [
                {
                    value: "",
                    text: i18n.t('register.select')
                },
                {
                    value: 1,
                    text: "1"
                },
                {
                    value: 2,
                    text: "2"
                },
                {
                    value: 3,
                    text: "3"
                },
                {
                    value: 4,
                    text: "4"
                },
                {
                    value: 5,
                    text: "5"
                },
                {
                    value: -1,
                    text: "5+"
                },
            ],

            // user inputs //

            selectedFacilityNumber: "",
            selectedEmployeeCount: "",
            selectedEmployeeCountID: "",
            
            email: "",
            password: "",

            name: "",
            surname: "",

            selectedSector: "",
            selectedDepartment: "",

            companyName: "",
            website: "",

            selectedCountry: null,
            selectedState: null,
            selectedProvince: null,
            address: "",

            selectedPlanID: null,
            paymentMethod: "monthly",

            selectedProductCode: "",
            selectedPrice: {},

            ///////////////////////////

            // sectors and departments //
            sectors: [],
            departments: [],

            // countries, states and provinces //
            countries: [],
            states: [],
            provinces: [],
            
            countryLoading: false,
            cityLoading: false,


            // assigned after the register request //

            companyID: null,

            // plans //

            prices: [],
            plans: [
              {
                id: 1,
                name: i18n.t('register.plans.free.name'),
                disabledPlans: false,
                features:{
                  green:[
                    i18n.t('register.plans.green._0'),
                    i18n.t('register.plans.green._1'),
                    i18n.t('register.plans.green._2'),
                    i18n.t('register.plans.green._7'),
                  ],
                  blue:[]
                },
                monthly: i18n.t('register.plans.free.monthly'),
                yearly: i18n.t('register.plans.free.yearly'),
                condition: i18n.t('register.plans.free.condition'),
              },
              {
                id: 2,
                name: i18n.t('register.plans.standard'),
                disabledPlans: true,
                features:{
                  green:[
                    i18n.t('register.plans.green._0'),
                    i18n.t('register.plans.green._1'),
                    i18n.t('register.plans.green._2'),
                    i18n.t('register.plans.green._7'),
                    i18n.t('register.plans.green._8'),
                  ],
                  blue:[
                    i18n.t('register.plans.blue._1'),
                    i18n.t('register.plans.blue._2'),
                    i18n.t('register.plans.blue._3'),
                    i18n.t('register.plans.blue._4'),
                  ]
                },
                monthly: "€19/month",
                yearly: "$190/year",
                condition: i18n.t('register.plans.condition'),
              },
              {
                id: 3,
                name: i18n.t('register.plans.premium'),
                disabledPlans: true,
                features:{
                  green:[
                    i18n.t('register.plans.green._0'),
                    i18n.t('register.plans.green._1'),
                    i18n.t('register.plans.green._2'),
                    i18n.t('register.plans.green._3'),
                    i18n.t('register.plans.green._4'),
                    i18n.t('register.plans.green._5'),
                    i18n.t('register.plans.green._7'),
                    i18n.t('register.plans.green._8'),
                    i18n.t('register.plans.green._9')
                  ],
                  blue:[
                    i18n.t('register.plans.blue._1'),
                    i18n.t('register.plans.blue._2'),
                    i18n.t('register.plans.blue._3'),
                    i18n.t('register.plans.blue._4'),
                  ]
                },
                monthly: "€34/month",
                yearly: "$340/year",
                condition: i18n.t('register.plans.condition'),
              },
              {
                id: 4,
                name: i18n.t('register.plans.enterprise'),
                disabledPlans: true,
                features:{
                  green:[
                    i18n.t('register.plans.green._0'),
                    i18n.t('register.plans.green._1'),
                    i18n.t('register.plans.green._2'),
                    i18n.t('register.plans.green._3'),
                    i18n.t('register.plans.green._4'),
                    i18n.t('register.plans.green._5'),
                    i18n.t('register.plans.green._6'),
                    i18n.t('register.plans.green._7'),
                    i18n.t('register.plans.green._8'),
                    i18n.t('register.plans.green._9')
                  ],
                  blue:[
                    i18n.t('register.plans.blue._1'),
                    i18n.t('register.plans.blue._2'),
                    i18n.t('register.plans.blue._3'),
                    i18n.t('register.plans.blue._4'),
                  ]
                },
                monthly: "€59/month",
                yearly: "$590/year",
                condition: i18n.t('register.plans.condition'),
              },
            ],

            // languages //

            language: null,
            languageOptions: [
              { value: 'tr', text: 'TR' },
              { value: 'en', text: 'EN' },
            ],

            // modals //

            proceedClicked: false,
            checkoutFormContent: "",
            subscriptionToken: "",
            formContentLoaded: false,

            shakeScreen: false,
        }
    },

    computed: {
      mailDisabled(){
        const hasSpecialChar = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.email);
        const isValidLength = (this.email.length > 4);

        return hasSpecialChar && isValidLength;
      },
      passwordDisabled(){
        const hasLowercase = /[a-z]/.test(this.password);
        const hasUppercase = /[A-Z]/.test(this.password);
        const hasNumber = /[0-9]/.test(this.password);
        const isLong = (this.password.length > 7);

        return hasLowercase && hasUppercase && hasNumber && isLong;
      },
      hasInviteToken() {
        return !!this.$route.query.token;
      },
    },

    mounted(){
        this.language = localStorage.getItem("lang") === "tr" | "en" ? localStorage.getItem("lang") : "en";
        this._getSectors();
        this._getDepartments();
        this._getPrices();
        this._getEmployeeCount();

        // location //
        this._getCountries();

        this.mountedPaymentMethod();

        // Invite-token-driven register: force the starter plan (id=1) and let the activeStep watcher
        // bypass the plan-selection step. The token is consumed on the backend during register.
        if (this.$route.query.token) {
            this.selectedPlanID = 1;
        }
    },

    watch: {
        activeStep(newVal, oldVal) {
            // Suppliers arriving via an invite token skip the plan-selection step entirely.
            if (newVal === 3 && this.hasInviteToken) {
                this.$nextTick(() => {
                    this.activeStep = (typeof oldVal === 'number' && oldVal > newVal) ? newVal - 1 : newVal + 1;
                });
                return;
            }
            if (newVal === 3) {
                this.$nextTick(() => {
                    this.mountedPaymentMethod();
                })
            }
        },

        selectedCountry(newVal, oldVal) {
            if (newVal && newVal != oldVal) {
                this._getStatesByCountryId(newVal.add_country_id);
            }
        },

        selectedState(newVal, oldVal) {
            if (!this.selectedCountry) return;

            if (newVal && newVal != oldVal && this.selectedCountry.has_state) {
                this._getProvincesByStateId(newVal.add_state_id);
            }
        },
    },

    methods: {
        // requests to use //

        ...mapActions("additionalsettings", [
            "getSector",
        ]),
        ...mapActions("settings", [
            "getDepartments"
        ]),
        ...mapActions("register", [
            "getEmployeeCount",
            "getPrices",
            "startSubscription",
            "startSinglePayment"
        ]),
        ...mapActions("company", [
            "getCountries",
            "getStatesByCountryId",
            "getProvincesByStateId",
        ]),
        ...mapActions('auditor', [
            'registerAsAuditor'
        ]),

        // sectors and departments //

        async _getSectors() {
            const params = {
                created_by: 81,
                is_deleted: false
            };
            const _sectors = await this.getSector(params)
                .then( res => {
                    const temp = res.data.map(item => ({
                            "value": item.sust_sector_id,
                            "text": item.sust_sector_name
                        })
                    );

                    return temp;
                })

            this.sectors = _sectors;
            this.sectors.push(
                {
                    "value": "",
                    "text": i18n.t('register.select')
                }
            )
        },
        async _getDepartments() {
            const params = {
                is_deleted: false
            };
            const _departments = await this.getDepartments(params)
                .then( res => {
                    let temp = [];

                    for (const item of res.data) {
                        if (item.role_id != 7) {
                            temp.push({
                                "value": item.user_department_id,
                                "text": item.user_department_name
                            })
                        }
                    }

                    return temp;
                })

            this.departments = _departments;
            this.departments.push(
                {
                    "value": "",
                    "text": i18n.t('register.select')
                }
            )
        },

        // addrmiddleware //

        _getCountries() {
            this.getCountries()
                .then(res => {
                    this.countries = res.data;
                })
                .catch(error => {
                    console.error(error);
                })
        },

        _getStatesByCountryId(id) {
            this.getStatesByCountryId({country_id: id})
                .then(res => {
                    this.states = res.data;
                    
                    if (this.selectedState) {
                        this.selectedState = res.data.find(x => x.add_state_id == this.selectedState.add_state_id);
                    }
                })
                .catch((err) => {
                    console.error(err);
                })
        },

        _getProvincesByStateId(id) {
            this.getProvincesByStateId({state_id: id})
                .then(res => {
                    this.provinces = res.data;
                    
                    if (this.selectedProvince) {
                        this.selectedProvince = res.data.find(x => x.add_province_id == this.selectedProvince.add_province_id);
                    }
                })
                .catch((err) => {
                    console.error(err);
                })
        },

        // payment api //

        _startSubscription(company_id) {
            const params = {
                locale: this.language,
                customer: {
                    name: this.name,
                    surname: this.surname,
                    identityNumber: "11111111",
                    email: this.email,
                    gsmNumber: "+905350000000",
                    billingAddress: {
                        contactName: `${this.name}${this.surname}`,
                        district: this.selectedProvince ? this.selectedProvince.add_state_name : '',
                        city: this.selectedState.add_state_name,
                        country: this.selectedCountry.add_country_name,
                        address: this.address,
                        // zipCode: "34000"
                    }
                },
                productCode: this.selectedProductCode,
                price: this.selectedPrice.monthly,
                conversationId: company_id
            }

            this.startSubscription(params)
                .then( res => {
                    this.checkoutFormContent = res.data.checkoutPage;
                    this.subscriptionToken = res.data.token;
                })
                .catch(({ response }) => {
                  this.$toast.open({
                    message: this.$parseResMessage(response.data.messageName),
                    type: "error",
                    duration: 5000,
                    dismissible: true,
                  });
                })
                .finally(() => {
                    this.formContentLoaded = true;
                    sessionStorage.setItem("subscription-token", this.subscriptionToken);
                })
        },

        _startSinglePayment(company_id) {
            const date = new Date();
            const formattedDate = `${date.getFullYear()}-${date.getMonth()+1}-${date.getDate()} ${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}`

            const params = {
                locale: this.language,
                price: this.selectedPrice.yearly,
                conversationId: company_id,
                buyer: {
                    id: "BY789",
                    name: this.name,
                    surname: this.surname,
                    gsmNumber: "+905350000000",
                    email: this.email,
                    identityNumber: "11111111111",
                    lastLoginDate: formattedDate,
                    registrationDate: formattedDate,
                    registrationAddress: this.address,
                    city: this.selectedState.add_state_name,
                    country: this.selectedCountry.add_country_name,
                },
                billingAddress: {
                    city: this.selectedState.add_state_name,
                    country: this.selectedCountry.add_country_name,
                    address: this.address
                }
            }
            
            this.startSinglePayment(params)
                .then( res => {
                    this.checkoutFormContent = res.data.checkoutPage;
                    this.subscriptionToken = res.data.token
                })
                .catch(({ response }) => {
                  this.$toast.open({
                    message: this.$parseResMessage(response.data.messageName),
                    type: "error",
                    duration: 5000,
                    dismissible: true,
                  });
                })
                .finally(() => {
                    this.formContentLoaded = true;
                    sessionStorage.setItem("subscription-token", this.subscriptionToken);
                })
        },


        // event handlers //

        selectPlan(id, pricing, product_code){
            if (id != 1) {
                window.open("https://www.sustainfinity.com/contact-us");
                return;
            }

            this.selectedPlanID = id;
            this.selectedProductCode = product_code;

            const monthlyIndex = pricing.monthly.indexOf("/");
            const yearlyIndex = pricing.yearly.indexOf("/");
            this.selectedPrice.monthly = parseInt(pricing.monthly.substring(1, monthlyIndex));
            this.selectedPrice.yearly = parseInt(pricing.yearly.substring(1, yearlyIndex));

            const allElements = document.querySelectorAll('*');
            const selected = document.querySelector(`.plan-${id}`);
            allElements.forEach(item => {
                item.classList.remove('selected-plan')
              });
            selected.classList.toggle('selected-plan');

            this.proceedClicked = true;

            this.handleClickNext();
        },

        changePrices() {
            if (this.selectedEmployeeCount[0] && this.selectedFacilityNumber) {
                this.setPricesForEmployeeNumber();
            }
        },

        handlePasswordHide() {
            this.passwordInput = this.passwordInput === "password" ? "text" : "password";
        },


        handleCompleteRegister() {
            const params = {
              email: this.email,
              userpwd: this.password,
              plan_id: this.selectedPlanID,
              firstname: this.name,
              surname: this.surname,
              user_department_id: this.selectedDepartment,
              total_employee_number: Number(this.selectedEmployeeCount),
              facility_number: this.selectedFacilityNumber,
              sector_id: this.selectedSector,
              company_name: this.companyName,
              website: this.website,
              add_country_id: this.selectedCountry.add_country_id,
              add_state_id: this.selectedState.add_state_id,
              add_province_id: this.selectedProvince ? this.selectedProvince.add_province_id : null,
              address: this.address
            };

            if (this.$route.query.token) {
              params.invite_token = this.$route.query.token;
              // Supplier invite registers on the starter plan. Force both the payload field and
              // the data field — the `.finally()` block below branches on selectedPlanID.
              params.plan_id = 1;
              this.selectedPlanID = 1;
            }

            const apiURL = axios.defaults.baseURL;
            const endpoint = "/api/auth/register";
            const fullUrl = `${apiURL}${endpoint}`;

            let company_id = null;

            axios.post(fullUrl, params, { withCredentials: true })
              .then( res => {
                company_id = res.data.company_id.company_id;
                this.$toast.open({
                  message: this.$parseResMessage(res.data.messageName),
                  type: "success",
                  duration: 5000,
                  dismissible: true,
                });
              })
              .catch(({ response }) => {
                this.$toast.open({
                  message: this.$parseResMessage(response.data.messageName),
                  type: "error",
                  duration: 5000,
                  dismissible: true,
                });
              })
              .finally(() => {
                if (this.selectedPlanID === 1) {
                    this.registeredAsStarter = true;
                    return;
                } else if (this.selectedPlanID === 2 || this.selectedPlanID === 3 || this.selectedPlanID === 4) {
                    this.paymentMethodController(company_id);
                } else {
                    throw new Error("Invalid Plan ID!");
                }
              })
        },
        handleClickNext() {
            try {
                if (this.activeStep === 2) {
                    this.changePrices();
                    window.document.querySelector(".register-company-container").style.height = "100%"; 
                    window.document.querySelector(".register-company-container").style.minHeight = "920px"; 
                    window.document.querySelector(".register-company-container").style.overflowY = "auto";
                } else {
                    window.document.querySelector(".register-company-container").style.height = "100vh";
                    window.document.querySelector(".register-company-container").style.minHeight = ""; 
                    window.document.querySelector(".register-company-container").style.overflowY = "hidden";
                }
                if (this.activeStep === 5) {
                    this.handleCompleteRegister(); // payment method controller called in .finally //
                    sessionStorage.setItem("name", this.name);
                }
            } catch (error) {
                console.error(error);
            } finally {
                this.activeStep++;
            }
        },
        paymentMethodController(company_id) {
            if (this.paymentMethod === "monthly") {
                this._startSubscription(company_id);
            } else if (this.paymentMethod === "yearly") {
                this._startSinglePayment(company_id);
            } else {
                throw new Error("Invalid Payment Method!");
            }
        },

        handleClickBack() {
            if (this.activeStep !== 1) {
                if (this.activeStep === 4) {
                    window.document.querySelector(".register-company-container").style.height = "100%"; 
                    window.document.querySelector(".register-company-container").style.minHeight = "920px"; 
                    window.document.querySelector(".register-company-container").style.overflowY = "auto"; 
                } else {
                    window.document.querySelector(".register-company-container").style.height = "100vh";
                    window.document.querySelector(".register-company-container").style.minHeight = ""; 
                    window.document.querySelector(".register-company-container").style.overflowY = "hidden";
                }

                this.activeStep--;
            } else {
                return;
            }
        },
        async selectEmployeeCount(item) {
            await this.setEmployeeCountID(item);
            await this.setEmployeeCount(item);
        },

        async setEmployeeCountID(val) {
            this.selectedEmployeeCountID = val.value[0];
        },

        async setEmployeeCount(val) {
            this.selectedEmployeeCount = val.value[1];
        },

        selectPaymentMethod() {
            if (this.paymentMethod === "monthly") {
                this.paymentMethod = "yearly";
            } else if (this.paymentMethod === "yearly") {
                this.paymentMethod = "monthly";
            } else {
                throw new Error("Invalid Payment Method!");
            }
        },

        setPaymentMethodSlider() {
            const thumb = window.document.getElementById("slider-thumb");

            if(this.paymentMethod === "monthly") {
                thumb.style.right = "2.5%";
                thumb.style.left = "";
            } else if (this.paymentMethod === "yearly") {
                thumb.style.right = "";
                thumb.style.left = "2.5%";
            } else {
                throw new Error("Invalid Payment Method!");
            }

            this.selectPaymentMethod();
        },
        
        mountedPaymentMethod() {
            this.setPaymentMethodSlider();
        },

        // price utilities

        _getEmployeeCount() {
            this.getEmployeeCount()
                .then( res => {
                  const data = res.data.sort((a,b) => a.register_employee_count_id - b.register_employee_count_id);

                  data.forEach((element, index) => {
                    this.employeeCount[index].value[0] = element.register_employee_count_id;
                    this.employeeCount[index].value[1] = element.max_employee_count;
                  });
                })
                .catch( err => {
                  console.error(err);
                })
        },

        _getPrices() {
          this.getPrices()
            .then( res => {
              res.data.forEach(element => {
                this.prices.push(element);
              });
            })
            .catch( err => {
              console.error(err);
            })
        },

        setPricesForEmployeeNumber(){
          const countID = this.selectedEmployeeCountID;
          const prices = this.prices;
          const startingPlanID = 2; // the plan ID that comes from the backend starts with "2"

          const relevantPrices = prices.filter( item => item.register_employee_count_id === countID);

          this.plans[1].monthly = `€${this.priceMultiplierPerFacility(relevantPrices.find( item => item.plan_id === startingPlanID && item.is_annual === false ).price)}${ i18n.t('register.plans.month') }`;
          this.plans[2].monthly = `€${this.priceMultiplierPerFacility(relevantPrices.find( item => item.plan_id === startingPlanID+1 && item.is_annual === false ).price)}${ i18n.t('register.plans.month') }`;
          this.plans[3].monthly = `€${this.priceMultiplierPerFacility(relevantPrices.find( item => item.plan_id === startingPlanID+2 && item.is_annual === false ).price)}${ i18n.t('register.plans.month') }`;
          this.plans[1].yearly = `€${this.priceMultiplierPerFacility(relevantPrices.find( item => item.plan_id === startingPlanID && item.is_annual === true ).price)}${ i18n.t('register.plans.year') }`;
          this.plans[2].yearly = `€${this.priceMultiplierPerFacility(relevantPrices.find( item => item.plan_id === startingPlanID+1 && item.is_annual === true ).price)}${ i18n.t('register.plans.year') }`;
          this.plans[3].yearly = `€${this.priceMultiplierPerFacility(relevantPrices.find( item => item.plan_id === startingPlanID+2 && item.is_annual === true ).price)}${ i18n.t('register.plans.year') }`;
          this.plans[1].productCode = relevantPrices.find( item => item.plan_id === startingPlanID && item.is_annual === false).product_code; 
          this.plans[2].productCode = relevantPrices.find( item => item.plan_id === startingPlanID+1 && item.is_annual === false).product_code; 
          this.plans[3].productCode = relevantPrices.find( item => item.plan_id === startingPlanID+2 && item.is_annual === false).product_code;

          if (countID === 6 || this.selectedFacilityNumber === -1) {
            window.open("https://www.sustainfinity.com/contact-us");
          }
        },

        priceMultiplierPerFacility(price) {
          // increase price by 5% for each facility (-1 is because the company has to have a minimum of 1 facility anyway)
          const multiplier = ( (this.selectedFacilityNumber -1) * 5 + 100) / 100;
          let newPrice = price * multiplier;

          newPrice = Math.ceil(newPrice)

          return newPrice
        },


        // animation control //

        animControl() {
            this.shakeScreen = !this.shakeScreen;
        },


        // languages //

        changeLang() {
            try {
                if (this.language === "en") {
                    this.language = "en";
                    localStorage.setItem("lang", "en");
                    this.$i18n.locale = "en";
                } else if (this.language === "tr") {
                    this.language = "tr";
                    localStorage.setItem("lang", "tr");
                    this.$i18n.locale = "tr";
                } else {
                    throw new Error("Invalid Language!");
                }
            } catch (error) {
                console.error(error);
            }/*  finally {
                window.location.reload();
            } */
        },

        // AUDITOR //

        setAuditorRegister() {
            if (this.mailDisabled === true && this.passwordDisabled === true) {
                this.activeStep = -1;
            } else {
                this.$notify('error', i18n.t('auditor.register.validation_error'), true);
            }
        },

        _registerAsAuditor() {
            const body = {
                company_name: this.companyName,
                user: {
                    firstname: this.name,
                    surname: this.surname,
                    email: this.email,
                    pwd: this.password
                }
            };
        
            this.registerAsAuditor(body)
                .then(res => {
                    this.activeStep = 6;
                    this.registeredAsStarter = true;
                    this.$notify('success', res.data.messageName);
                })
                .catch(({ response }) => {
                    this.$notify('error', response.data.messageName);
                })
        }
    }
}
</script>

<template>
  <div class="register-company-container" :class="{'shake-animation': shakeScreen}" @animationend="animControl">
    
            <div class="language-box-container">
                <i class="mdi mdi-translate" 
                    style="
                        z-index: 1; 
                        color: white;
                        padding-right: .25em;
                        margin-bottom: .75em;
                        font-size: 2em
                    "
                ></i>
                <b-form-select
                    :options="languageOptions"
                    v-model="language"
                    @change="changeLang"
                >
                </b-form-select>
            </div>

            <div class="step-card" v-if="activeStep === -1">
                <div class="back-button" @click="() => activeStep = 1">
                    <i class="fa-solid fa-chevron-left"></i> {{ $t('register.prev_button') }}
                </div>
                <div class="step-indicator">
                    {{ $t('auditor.register.step') }}
                </div>
                <div class="class-or--header">
                    <div class="line-or--header" style="font-size: .7em;">
                        {{ $t('auditor.register.info') }}
                    </div>
                </div>
                <div class="register-input-1">
                    <div class="input-label text-left" style="min-width: fit-content;">
                        {{ $t('register.name') }}:
                    </div>
                    <input type="text" class="register-text-input" v-model="name">
                </div>
                <div class="register-input-1">
                    <div class="input-label text-left" style="min-width: fit-content;">
                        {{ $t('register.surname') }}:
                    </div>
                    <input type="text" class="register-text-input" v-model="surname">
                </div>
                <div class="register-input-1">
                    <div class="input-label text-left" style="min-width: fit-content;">
                        {{ $t('register.company_name') }}:
                    </div>
                    <input type="text" class="register-text-input" v-model="companyName">
                </div>

                <b-button class="select-plan--button" @click="_registerAsAuditor()"
                    :disabled="companyName.length === 0 || name.length === 0 || surname.length === 0"
                    :class="{'select-plan--button-disabled': companyName.length === 0 || name.length === 0 || surname.length === 0}"
                >
                    {{ $t('register.complete') }}
                </b-button>
            </div>

            <div v-if="activeStep === 0"
                class="step-card"
            >
                <div style="padding: 0 1em;">
                    <p style="font-size: 1.1em; color: var(--sustainfinity-blue);">
                        {{ $t('register.initial_warning.0') }}
                    </p>
                    <p style="font-size: 1.1em; font-weight: bold; color: var(--sustainfinity-navy);">
                        {{ $t('register.initial_warning.1') }}
                    </p>
                </div>
                <b-button class="select-plan--button" @click="handleClickNext">
                    {{ $t('register.next_button') }}
                </b-button>
            </div>

            <div class="step-card" v-if="activeStep === 1">
                <div class="step-indicator">
                    {{ activeStep }}/5
                </div>
                <div class="class-or--header">
                    <div class="line-or--header" style="font-size: 1em;">
                        {{ $t('register.create_account') }}
                    </div>
                </div>

                <div class="register-input-1">
                    <i class="fa-solid fa-circle-info"
                        v-b-tooltip.hover.left="{title: $t('register.email_warning')}"
                        :style="{color: mailDisabled ? null : 'var(--invalid-input)'}"
                    ></i>
                    <div class="input-label" style="width: 7.5em">
                        {{ $t('register.email') }}:
                    </div>
                    <input type="text" class="register-text-input" v-model="email">
                </div>
                <div class="register-input-1">
                    <i class="fa-solid fa-circle-info"
                        v-b-tooltip.hover.left="{title: $t('register.password_conditions')}"
                        :style="{color: passwordDisabled ? null : 'var(--invalid-input)'}"
                    ></i>
                    <div class="input-label" style="width: 7.5em">
                        {{ $t('register.password') }}:
                    </div>
                    <input :type="passwordInput" class="register-text-input" v-model="password">
                    <i @click="handlePasswordHide" v-if="passwordInput == 'password'" class="password-hide fa-regular fa-eye"></i>
                    <i @click="handlePasswordHide" v-else class="password-hide fa-regular fa-eye-slash"></i>
                </div>

                <div class="click-to-register-auditor" @click="setAuditorRegister()">
                    {{ $t('auditor.register.click_here') }}
                </div>

                <b-button class="select-plan--button" @click="handleClickNext"
                    :disabled="!mailDisabled || !passwordDisabled"
                    :class="{'select-plan--button-disabled': !mailDisabled || !passwordDisabled}"
                >
                    {{ $t('register.next_button') }}
                </b-button>
                <div class="privacy-note">
                    {{ $t('register.privacy_notice') }}
                </div>
            </div>

            <div class="step-card" v-if="activeStep === 2">
                <div class="back-button" @click="handleClickBack">
                    <i class="fa-solid fa-chevron-left"></i> {{ $t('register.prev_button') }}
                </div>
                <div class="step-indicator">
                    {{ activeStep }}/5
                </div>
                <div class="register-card-header">
                    {{ $t('register.HM_employee' )}}
                </div>
                <div class="employee-counts">
                    <div class="employee-count-option" v-for="item in employeeCount" :key="item"
                        :class="{'selected-employee-count-option': selectedEmployeeCountID == item.value[0]}"
                        @click="selectEmployeeCount(item)"
                    >
                        {{ item.text }}
                    </div>
                </div>
                <div class="register-card-header">
                    {{ $t('register.HM_facility') }}
                </div>
                <div class="register-input-1 ">
                    <select id="facilitySelector" style="width: 100%;" class="register-text-input" v-model="selectedFacilityNumber">
                        <option style="text-align: center;" v-for="item in facilityNumber" :key="item" :value="item.value">
                            {{ item.text }}
                        </option>
                    </select>
                </div>
                <b-button class="select-plan--button" @click="handleClickNext"
                    :disabled="!selectedEmployeeCount || !selectedFacilityNumber"
                    :class="{'select-plan--button-disabled': !selectedEmployeeCount || !selectedFacilityNumber}"
                >
                    {{ $t('register.next_button') }}
                </b-button>
            </div>

            <div v-if="activeStep === 3" class="plans-step">
                    <div class="back-button_wbg" @click="handleClickBack">
                        <i class="fa-solid fa-chevron-left"></i> {{ $t('register.prev_button') }}
                    </div>
                    <div class="step-indicator_wbg">
                        {{ activeStep }}/5
                    </div>
                    <div class="payment-method-slider">
                        <div id="slider-left-label" class="slider-label">{{ $t('register.monthly') }}</div>
                        <div id="slider-track" @click="setPaymentMethodSlider">
                            <div id="slider-thumb"></div>
                        </div>
                        <div id="slider-right-label" class="slider-label">{{ $t('register.annual') }}</div>
                    </div>
                    <div class="plan_wrapper">
                        <div v-for="(plan, planIndex) in plans" :key="planIndex" class="plan" :class="`plan-`+plan.id">
                            <div class="class-or--header">
                                <hr class="line-1--header">
                                <div class="line-or--header">
                                    {{ plan.name }}
                                </div>
                                <hr class="line-2--header">
                            </div>
                        
                            <!-- <div class="monthly" v-if="paymentMethod === 'monthly'">
                                {{ plan.monthly }}
                            </div>
                            <div class="annual" v-if="paymentMethod === 'yearly'">
                                {{ plan.yearly }}
                            </div> -->
                            <div class="condition" v-if="planIndex === 0">
                                {{ plan.condition }}
                            </div>
                        
                            <b-button class="select-plan--button" @click="selectPlan(plan.id, {monthly: plan.monthly, yearly: plan.yearly}, plan.productCode)">
                                {{ plan.id == 1 ? $t('register.select_button') : $t('register.contact_us_short') }}
                            </b-button>
                        
                            <div class="feature" v-for="item in plan.features.green" :key="item">
                                <i class="fa-solid fa-check feature-green"></i>
                                <span style="padding-right:3px ;">{{ item }}</span>
                                </div>
                            
                            <div class="feature" v-for="item in plan.features.blue" :key="item">
                                <i class="fa-solid fa-check feature-blue"></i>
                                <span style="padding-right:3px ;">{{ item }}</span>
                            </div>
                        
                        </div>
                    </div>
                    <div class="plans-step-footer">
                        <div class="blue-tick-explanation">
                            <i class="fa-solid fa-check"></i>
                            {{ $t('register.not_included') }}
                        </div>

                        <div class="contact-us-section">
                            <div>
                                {{ $t('register.contact_us') }} 
                            </div>
                            <div>
                                <b-button class="select-plan--button" href="https://www.sustainfinity.com/contact-us">
                                    {{ $t('register.contact_us_button') }}
                                </b-button>
                            </div>
                        </div>
                    </div>
            </div>

            <div class="step-card" v-if="activeStep === 4">
                <div class="back-button" @click="handleClickBack">
                    <i class="fa-solid fa-chevron-left"></i> {{ $t('register.prev_button') }}
                </div>
                <div class="step-indicator">
                    {{ activeStep }}/5
                </div>
                <div class="register-card-header mt-4">
                    {{ $t('register.your_name') }}
                </div>
                <div class="register-input-1">
                    <div class="input-label text-right" style="width: 8em;">
                        {{ $t('register.name') }}:
                    </div>
                    <input type="text" class="register-text-input" v-model="name">
                </div>
                <div class="register-input-1">
                    <div class="input-label text-right" style="width: 8em;">
                        {{ $t('register.surname') }}:
                    </div>
                    <input type="text" class="register-text-input" v-model="surname">
                </div>
                <div class="register-card-header mt-4">
                    {{ $t('register.your_company_name') }}
                </div>
                <div class="register-input-1">
                    <div class="input-label text-right" style="width: 8em;">
                        {{ $t('register.company_name') }}:
                    </div>
                    <input type="text" class="register-text-input" v-model="companyName">
                </div>
                <div class="register-card-header mt-4">
                    {{ $t('register.your_department') }}
                </div>
                <div class="register-input-1 ">
                    <select style="width: 100%;" class="register-text-input" v-model="selectedDepartment">
                        <option style="text-align: center;" v-for="item in departments" :key="item" :value="item.value">
                            {{ item.text }}
                        </option>
                    </select>
                </div>
                <b-button class="select-plan--button" @click="handleClickNext"
                    :disabled="!name || !surname || !companyName || !selectedDepartment"
                    :class="{'select-plan--button-disabled': !name || !surname || !companyName || !selectedDepartment}"
                >
                    {{ $t('register.next_button') }}
                </b-button>
            </div>

            <div class="step-card" v-if="activeStep === 5">
                <div class="back-button" @click="handleClickBack">
                    <i class="fa-solid fa-chevron-left"></i> {{ $t('register.prev_button') }}
                </div>
                <div class="step-indicator">
                    {{ activeStep }}/5
                </div>
                <div class="register-card-header mt-4">
                    {{ $t('register.your_industry') }}
                </div>
                <div class="register-input-1 ">
                    <select style="width: 100%;" class="register-text-input" v-model="selectedSector">
                        <option style="text-align: center;" v-for="item in sectors" :key="item" :value="item.value">
                            {{ item.text }}
                        </option>
                    </select>
                </div>
                <div class="register-card-header mt-4">
                    {{ $t('register.your_company_website') }}
                </div>
                <div class="register-input-1">
                    <div class="input-label text-left" style="width: fit-content">
                        {{ $t('register.company_website') }}:
                    </div>
                    <input type="text" class="register-text-input" v-model="website">
                </div>
                <div class="register-card-header mt-4">
                    {{ $t('register.your_company_location') }}
                </div>
                <div class="location-section">
                    <div class="location-select">
                        <div>
                            <span>
                                {{ $t('companyOperations.modal.country') }}
                            </span>
                        </div>
                        <select v-model="selectedCountry">
                            <option style="text-align: center;" v-for="item in countries" :key="item.add_country_id"
                                :value="item"
                            >
                                {{ item.add_country_name }}
                            </option>
                        </select>
                    </div>
                    
                    <div class="location-select">
                        <div>
                            <span for="input" v-if="selectedCountry && selectedCountry.has_state">
                                {{ $t('companyOperations.modal.state') }}
                            </span>
                            <span for="input" v-else-if="selectedCountry && !selectedCountry.has_state">
                                {{ $t('companyOperations.modal.province') }}
                            </span>
                            <span for="input" v-else>
                                {{ $t('companyOperations.modal.state') }} / {{ $t('companyOperations.modal.province') }}
                            </span>

                            <div v-if="countryLoading" class="address-spinner float-right">
                              <b-spinner variant="success" label="Loading..."></b-spinner>
                            </div>
                        </div>
                        <select v-model="selectedState" :disabled="selectedCountry == null">
                            <option style="text-align: center;" v-for="item in states" :key="item.add_state_id"
                                :value="item"
                            >
                                {{ item.add_state_name }}
                            </option>
                        </select>
                        
                    </div>
                    
                    <div class="location-select" v-if="selectedCountry && selectedCountry.has_state">
                        <div>
                            <span>
                                {{ $t('companyOperations.modal.province') }}
                            </span>

                            <div v-if="cityLoading" class="address-spinner float-right">
                              <b-spinner variant="success" label="Loading..."></b-spinner>
                            </div>
                        </div>
                        <select v-model="selectedProvince" :disabled="selectedState == null">
                            <option style="text-align: center;" v-for="item in provinces" :key="item.add_province_id"
                                :value="item"
                            >
                                {{ item.add_province_name }}
                            </option>
                        </select>
                    </div>
                </div>
                <br>

                <div class="p-3">
                    <div class="input-label text-left mx-auto pl-3">
                        {{ $t('register.address') }}:
                    </div>
                    <b-form-textarea
                        rows="3"
                        v-model="address"
                        style="min-height: 3em;"
                    >
                    </b-form-textarea>
                </div>

                <b-button class="select-plan--button" @click="handleClickNext"
                    :disabled="!selectedSector || !website || !selectedCountry || !selectedState || !address"
                    :class="{
                        'select-plan--button-disabled': !selectedSector || !website || !selectedCountry || !selectedState || !address
                    }"
                >
                    {{ $t('register.complete') }}
                </b-button>
            </div>

            <subscription :page="checkoutFormContent" v-if="activeStep === 6 && formContentLoaded === true"></subscription>
            <starter-complete v-if="activeStep === 6 && registeredAsStarter"></starter-complete>

  </div>
</template>

<style lang="scss" scoped>

* {
    color: black;
}

.register-company-container {
    background-image: url("/images/sust-register-bg.png");
    background-size: cover;
    background-attachment: fixed;
    height: 100vh;
    width: 100%;

    display: flex;
    flex-direction: row;
    justify-content: center;
    align-content: center;
    align-items: center;
}

.shake-animation {
    animation: shake 0.3s;
}
@keyframes shake {
  0% { transform: translate(1px, 1px) rotate(0deg); }
  10% { transform: translate(-1px, -2px) rotate(-1deg); }
  20% { transform: translate(-3px, 0px) rotate(1deg); }
  30% { transform: translate(3px, 2px) rotate(0deg); }
  40% { transform: translate(1px, -1px) rotate(1deg); }
  50% { transform: translate(-1px, 2px) rotate(-1deg); }
  60% { transform: translate(-3px, 1px) rotate(0deg); }
  70% { transform: translate(3px, 1px) rotate(-1deg); }
  80% { transform: translate(-1px, -1px) rotate(1deg); }
  90% { transform: translate(1px, 2px) rotate(0deg); }
  100% { transform: translate(1px, -2px) rotate(-1deg); }
}

.company-bar {
    margin: auto;
    border-bottom: thin solid gray;

    justify-content: space-between;

    position: relative;
}

.container {
    justify-content: center;
    width: 100%;
    height: 100%;
}

.container > div {
    padding: 1em;
}
.credentials-tab {
    border-right: thin solid lightgray;
}
.plan-row {
    padding: .33em;
}

.plan {
    position: relative;

    width: fit-content !important;
    height: fit-content;
    max-width: 25em;
    min-height: 45em;

    border: thin solid gray;
    border-radius: 1em;

    margin: auto;
    padding-top: 2.5em;

    text-align: center;

    box-shadow: 0 0 .66em .1em gray;

    background-color: whitesmoke;

    margin: .5em;
}

.step-card {
    position: relative;

    max-width: 35em;
    width: fit-content !important;
    height: fit-content;

    border: thin solid gray;
    border-radius: 1em;

    margin: auto;
    padding-top: 2.5em;

    text-align: center;

    box-shadow: 0 0 .66em .1em gray;

    background-color: whitesmoke;

    margin: .5em;
}

.select-plan--button-disabled {
    pointer-events: none;
}
.select-plan--button {
    background-color: #0383ab;
    box-shadow: 0 0 .33em .33em lightgray;
    border: 0;
    border-radius: 1em;
    margin: 1em;
    width: 15rem;

    position: relative;

    > .fa-brands {
        position: absolute;
        right: .5em;
        top: 50%;
        transform: translateY(-50%);
        color: white;
        font-size: 1.2em;
    }
}
.select-plan--button:hover {
    background-color: #44a900;
    box-shadow: 0 0 .33em .33em lightgray;
}
.select-plan--button:focus {
    background-color: #44a900;
    box-shadow: 0 0 .33em .33em lightgray;
}
.selected-plan{
  box-shadow: inset 0 0 1em .2em var(--sustainfinity-blue) !important;
  outline: medium solid var(--sustainfinity-blue);
  border-color: var(--sustainfinity-blue);
  background-color: var(--sustainfinity-faded-blue);
}

.show-plan-benefits--button {
    background-color: #00556f;
    box-shadow: 0 0 .33em .33em lightgray;
    border: 0;
    border-radius: 1em;
    margin: 1em;
    width: 7.5rem;
}
.show-plan-benefits--button:hover {
    background-color: #44a900;
    box-shadow: 0 0 .33em .33em lightgray;
}
.show-plan-benefits--button:focus {
    background-color: #44a900;
    box-shadow: 0 0 .33em .33em lightgray;
}


.input-label {
    padding-top: .1em;
    padding-right: 0 !important;

    margin-left: .225em;
    margin-bottom: .33em;
    font-weight: bolder;

    width: fit-content;
}


.class-or--header {
    scale: 1;
    color: #0383ab;

    font-size: 2em !important;
}
.line-or--header {
    position: relative;
    padding-top: 0em;

    font-weight: bold;
    font-size: 1.25em;
    color: #0383ab;
}
.line-1--header {
    position: absolute;
    left: .1em;
    top: 0.33em;
    background-color: #0383ab;
    height: .15em;
    width: 15%;
}
.line-2--header {
    position: absolute;
    right: .1em;
    top: 0.33em;
    background-color: #0383ab;
    height: .15em;
    width: 15%;
}



.class-or {
    position: relative;
    scale: .75;
}
.line-or {
    position: relative;
    padding-top: .25em;

    font-weight: bold;
    font-size: 1.5em;
}
.line-1 {
    position: absolute;
    left: 0;
    top: 0.3em;
    background-color: #0383ab;
    height: .15em;
}
.line-2 {
    position: absolute;
    right: 0;
    top: 0.3em;
    background-color: #0383ab;
    height: .15em;
}


.monthly {
    color: #44a900;

    font-weight: bold;
    font-size: 1.33em;
}
.annual {
    color: #44a900;

    font-weight: bold;
    font-size: 1.33em;
}
.condition {
    font-size: 1em;
    font-weight: bold;
}

.feature {
    text-align: left;
    position: relative;
    font-size: .9em;
    font-weight: bold;
    padding-left: 1em;
}
.feature > span {
    padding-left: 1.33em;
}

.feature-green {
    position: absolute;
    top: .33em;
    color: #44a900;
}
.feature-blue {
    position: absolute;
    top: .33em;
    color: #0383ab;
}


.price-warning {
    color: #44a900; 
    font-weight: bolder; 
    font-style: italic;
    margin-left: 13.33em;
    margin-bottom: 1em;
}

.credential-condition {
    font-size: .9em;
    font-style: italic;
    font-weight: bold;
    color: #44a900;
    padding-top: .5em;
}
.privacy-note {
    font-size: .9em;
    font-style: italic;
    font-weight: bold;
    color: #023047bd;

    padding-top: 0 !important;
    padding: .5em;
}

.valid-false {
    box-shadow: 0 0 0.3em 0.1em rgb(255, 60, 0);
}
.valid-true {
    box-shadow: 0 0 0.3em 0.1em #44a900;
}

.language-tab {
    position: absolute;
    right: 15%;
    top: 50%;
    transform: translateY(-50%);
}

.language--button {
    cursor: pointer;
    color: #00556f;
    font-size: 1.5em;
    transition: scale 100ms;

    &:hover {
        scale: 1.1;
    }
}


.register-input-1 {
    margin-top: 1em;
    margin-left: .66em;
    margin-right: .66em;

    position: relative;

    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-content: center;
    align-items: center;

    border-bottom: thin solid black;

    padding-left: 1.5em;

    > .input-label {
        width: 5.5em;
        padding-right: 1em;
        text-align: right;
        white-space: nowrap;
    }

    > .fa-circle-info {
        position: absolute;
        color: gray;
        left: .25em;
        top: 50%;
        transform: translateY(-50%);

        transition: color 200ms;

        &:hover {
            color: var(--sustainfinity-navy)
        }
    }
    
}

.register-text-input {
    border: 0 !important;
    outline: 0 !important;
    padding: .4em;
    background-color: whitesmoke !important;
    width: 100%;
}

.password-hide {
    position: absolute;
    right: 1em;
    top: 50%;
    transform: translateY(-50%);
    cursor: pointer;
    font-size: 1.2em;
    transition: scale 100ms;

    &:hover {
        scale: 1.1;
    }
}

.step-indicator {
    position: absolute;
    top: .33em;
    right: .66em;
    color: gray;
    font-weight: bold;
}

.register-card-header {
    font-size: 1.33em;
    font-weight: bolder;
    color: var(--sustainfinity-blue);
}

.employee-counts {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-content: center;
    align-items: center;
    flex-wrap: wrap;

    padding: 1em;
}
.employee-count-option {
    margin: .33em;
    min-width: 40%;
    height: 10%;
    border: thin solid var(--sustainfinity-navy);
    border-radius: 1em;
    padding: 2em 1em 2em 1em;
    box-shadow: 0 0 .25em .05em gray;
    font-weight: bold;

    cursor: pointer;

    &:active {
        background-color: var(--sustainfinity-faded-blue);
        box-shadow: 0 0 .25em .05em var(--sustainfinity-blue) inset;
    }


    transition: box-shadow 200ms, background-color 200ms;
}

.selected-employee-count-option {
    border: 0;
    outline: medium solid var(--sustainfinity-blue);
    box-shadow: 0 0 1em .01em var(--sustainfinity-blue) inset;
}

.plans-step {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-content: center;
    align-items: center;
    flex-wrap: wrap;

    height: fit-content;

    padding: 1em;
    padding-top: 5em;

    position: relative;
}
.back-button {
    position: absolute;
    top: .5em;
    left: .5em;

    display: flex;
    flex-direction: row;

    > .fa-solid {
        padding-top: .3em;
        padding-right: .5em;
    }

    cursor: pointer;
    &:hover {
        border-bottom: thin solid black;
    }
}

.back-button_wbg {
    position: absolute;
    top: 1.5em;
    left: 3.33em;

    border-radius: .33em;

    padding: .5em 1em .5em 1em;

    color: black;
    background-color: whitesmoke;

    transition: background-color 200ms;


    display: flex;
    flex-direction: row;

    > .fa-solid {
        padding-top: .3em;
        padding-right: .5em;
    }

    cursor: pointer;
    &:hover {
        background-color: var(--sustainfinity-faded-blue);
    }
}
.step-indicator_wbg {
    position: absolute;
    top: 1.5em;
    right: 3.33em;

    border-radius: .33em;

    padding: .5em 1em .5em 1em;

    color: black;
    background-color: whitesmoke;
}
.payment-method-slider {
    position: absolute;
    left: 50%;
    top: 1em;
    transform: translateX(-50%);

    display: flex;
    flex-direction: row;
    justify-content: center;
    align-content: center;
    align-items: center;

    > .slider-label {
        color: white;
        font-weight: bold;
        padding: .66em;
        font-size: 20px;
        white-space: nowrap;
    }
    
    > .slider-label:nth-of-type(1) {
        text-align: right;
    }

    > #slider-track {
        cursor: pointer;

        width: 100px;
        height: 40px;
        border-radius: 20px;
        background-color: whitesmoke;

        position: relative;

        display: flex;
        align-content: center;
        align-items: center;

        > #slider-thumb {
            z-index: 99;
            width: 40px;
            height: 33px;
            border-radius: 1em;

            position: absolute;

            background-color: var(--sustainfinity-blue);
            box-shadow: 0 0 .33em .1em lightgray;

            transition: all 250ms;

            &:hover {
                background-color: var(--sustainfinity-navy);
            }
        }
    }

}

.plans-step-footer {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-content: center;
    align-items: flex-start;
    flex-wrap: wrap;

    font-weight: bold;
    padding: .33em 2.66em .33em 2.66em;

    width: 100%;

    margin-top: 1em;

    > .blue-tick-explanation {
        padding: 1em;

        display: flex;
        flex-direction: row;
        text-align: left;

        color: white;
        font-weight: bold;

        > .fa-check {
            padding-top: .25em;
            padding-right: .66em;
            color: var(--sustainfinity-blue);
        }
    }

    > .contact-us-section {
        padding-bottom: 1em;

        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        align-content: center;
        align-items: center;

        flex-wrap: wrap;

        padding: .5em;
        border-radius: 1em;
        box-shadow: 0 0 1em .33em gray;
        background-color: whitesmoke;

        > div {
            padding-right: .5em;
        }

    }
}

.location-section{
    padding-top: 1em;

    width: 100%;

    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-content: center;
    align-items: center;
    flex-wrap: wrap;
    
    > .location-select {
        border-radius: 1em;

        width: 27.5%;

        margin: auto;


        overflow: hidden;

        > div {
            position: relative;
            text-align: left;
            padding-left: .5em;

            overflow: visible;

            > .address-spinner {
                position: absolute;
                scale: .5;
                top: -.5em;
                right: 0;
            }

        }

        > select {
            width: 100%;
            border-radius: 1em;
            padding: .33em .5em .33em .5em;
        }

        
    }
}

.smaller-select-field {
    max-width: 200px;
}

.language-box-container {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-content: center;
    align-items: center;
    text-align: center;

    position: absolute;
    top: 2.5em;
    right: 2.5em;
} 
.plan_wrapper{
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        align-content: center;
        align-items: center;
        text-align: center;
        justify-content: center;
    }

@media screen and (max-width: 1500px){
    .plan_wrapper{
        width: 60%;
        height: 60%;
    }
}


@media screen and (max-width: 950px) {
    .slider-label {
        font-size: 16px !important;
    }
}
@media screen and (max-width: 650px) {
    .slider-label {
        font-size: 14px !important;
        white-space: wrap !important;
    }

    .payment-method-slider {
        top: 5em !important;
        > #slider-track {
            width: 80px !important;
            height: 30px !important;
            border-radius: 5px !important;

            > #slider-thumb {
                width: 20px !important;
                height: 20px !important;

                border-radius: 7px !important;
            }
        }
    }
    

    .plans-step {
        padding-top: 130px !important;
    }
}

input:-webkit-autofill,
input:-webkit-autofill:hover, 
input:-webkit-autofill:focus, 
input:-webkit-autofill:active{
    -webkit-box-shadow: 0 0 0 30px whitesmoke inset !important;
}

.click-to-register-auditor {
    margin: .5em 0;
    color: var(--sustainfinity-navy);

    cursor: pointer;
    transition: color 150ms;
    &:hover {
        color: var(--sustainfinity-blue);
        text-decoration: underline;
    }
}

</style>